import { useContext } from "react";

import {
  DocumentSelectionContext,
  type UseDocumentSelectionReturn,
} from "../contexts/DocumentSelectionContext";

export const useDocumentSelection = (): UseDocumentSelectionReturn => {
  const ctx = useContext(DocumentSelectionContext);
  if (!ctx) {
    throw new Error(
      "useDocumentSelection must be used within a DocumentSelectionProvider",
    );
  }
  return ctx;
};
